module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("设置")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-list"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('span', {
    staticClass: "input-num"
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "input-list"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("实名认证")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 0),
      expression: "status === 0"
    }],
    staticClass: "input-num",
    on: {
      "click": function($event) {
        _vm.$router.push('/auth/authentication')
      }
    }
  }, [_vm._v("未实名，去认证")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 1),
      expression: "status === 1"
    }],
    staticClass: "input-num"
  }, [_vm._v("已认证    " + _vm._s(_vm.name) + "    " + _vm._s(_vm.idcard))])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.btnText))])])]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b20a7ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/settings.vue
// module id = 351
// module chunks = 1